import { ChatMain } from '../components/chat/ChatMain';

export function Conversation() {
  return <ChatMain />;
}
